export default {
  methods: {
    messageValidation(error) {
      let text = null;

      if (error.required == false) {
        text = "Campo obligatorio";
      } else if (error.email == false) {
        text = "Email Inválido";
      } else if (error.numeric == false) {
        text = "Ingrese solo números";
      } else if (error.minLength == false) {
        text = `El campo debe tener mínimo ${error.minLength.$params.min} dígitos.`;
      } else if (eerror.maxLength == false) {
        text = `El campo debe tener máximo ${error.maxLength.$params.max} dígitos.`;
      } else if (error.sameAsPassword = false) {
        text = "Las contraseñas no coinciden";
      }

      return text;
    },
  },
};
